import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { loginUser, loginUserSuccess } from '../store/slices/authSlice';

export default function LoginPage() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isAuthenticating, statusText } = useAppSelector((s) => s.auth);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const ssoError = new URLSearchParams(window.location.search).get('sso_error');
  const ssoMessage: Record<string, string> = {
    no_account: 'Za ovaj Google email ne postoji korisnik na ovom restoranu.',
    email_unverified: 'Google email nije potvrđen.',
    invalid_state: 'Prijava putem Googlea je istekla. Pokušajte ponovno.',
    google_error: 'Google prijava nije uspjela. Pokušajte ponovno.',
    server_error: 'Greška poslužitelja. Pokušajte ponovno.',
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const result = await dispatch(loginUser({ email, password }));
    if (loginUser.fulfilled.match(result)) {
      // Dispatch loginUserSuccess so the socket middleware connects the WebSocket
      // loginUser.fulfilled only updates auth state in the slice, but the socket
      // middleware listens for loginUserSuccess to initiate the WS connection
      const token = result.payload.token;
      dispatch(loginUserSuccess(token));
      sessionStorage.removeItem('homeSeen');
      navigate('/');
    }
  };

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '100vh' }}>
      <Row className="w-100 justify-content-center">
        <Col xs={12} sm={8} md={6} lg={4}>
          <Card>
            <Card.Body>
              <h3 className="text-center mb-4">HalloChef</h3>
              {statusText && (
                <Alert variant="danger">{statusText}</Alert>
              )}
              {ssoError && (
                <Alert variant="danger">{ssoMessage[ssoError] || 'Google prijava nije uspjela.'}</Alert>
              )}
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="email">
                  <Form.Label>E-mail</Form.Label>
                  <Form.Control
                    type="email"
                    placeholder="Unesite e-mail"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    autoFocus
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId="password">
                  <Form.Label>Lozinka</Form.Label>
                  <Form.Control
                    type="password"
                    placeholder="Unesite lozinku"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </Form.Group>
                <Button variant="primary" type="submit" className="w-100" disabled={isAuthenticating}>
                  {isAuthenticating ? <Spinner animation="border" size="sm" /> : 'Prijava'}
                </Button>
              </Form>
              <div className="text-center text-muted my-3">ili</div>
              <Button
                variant="outline-secondary"
                className="w-100"
                onClick={() => { window.location.href = '/api/auth/google/start'; }}
              >
                Prijava putem Googlea
              </Button>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
